import React from "react";
import axios from "axios";
import "../../../assets/features.css";
import { BASE_URL, DAYS, HEADERS } from "../../../common/api";
import { DeleteButton, EditButton, AddButton } from "../../../assets/js/Button";
import { Modal, Form, Button } from "react-bootstrap";

class DeliveryDay extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      days: [],
      show: false,
      confirm: false,
      date_min: "",
      date_max: "",
      priority: "",
      isActive: false,
      id: "",
    };
    this._isMounted = false;
  }
  componentDidMount() {
    this._isMounted = true;
    this._isMounted &&
      axios.get(BASE_URL + DAYS).then((res) => {
        console.log(res.data);
        this.setState({ days: res.data });
      });
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.show && !this.state.show) {
      this.setState({
        show: false,
        date_min: "",
        date_max: "",
        priority: "",
        isActive: false,
        id: "",
      });
    }
  }

  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  showModal = () => {
    this.setState({ show: true });
  };

  showConfirmationModal = (event, id) => {
    this.setState({ confirm: true, id: id });
  };

  hideModal = () => {
    this.setState({ show: false, confirm: false });
  };

  get = (data) => {
    this.setState({
      date_min: data.date_min,
      date_max: data.date_max,
      id: data.id,
      priority: data.priority,
      isActive: data.isActive,
      show: true,
    });
  };

  delete = (id) => {
    const { days } = this.state;
    axios.delete(BASE_URL + DAYS + id).then((res) => {
      const updatedData = days.filter((day) => day.id !== id);
      this.setState({ days: updatedData, confirm: false });
    });
  };

  addOrUpdate = (event) => {
    event.preventDefault();
    const { date_min, date_max, priority, isActive, id } = this.state;
    let data = {
      date_min: date_min,
      date_max: date_max,
      priority: priority,
      isActive: isActive,
    };

    if (id) {
      axios.put(BASE_URL + DAYS + id + "/", data, HEADERS).then((res) => {
        const { days } = this.state;
        const index = days.findIndex((day) => day.id === id);
        days[index] = res.data;
        this.setState({ days: days, show: false });
      });
    } else {
      axios.post(BASE_URL + DAYS, data, HEADERS).then((res) => {
        this.setState({
          days: [...this.state.days, res.data],
          show: false,
        });
      });
    }
  };

  getTitle = () => {
    const { id } = this.state;
    if (id) {
      return <h3>Изменить</h3>;
    } else {
      return <h3>Добавить новый</h3>;
    }
  };

  render() {
    const { show, confirm, date_min, date_max, priority, isActive, id } =
      this.state;
    const { permission } = this.props;
    return (
      <>
        <Modal
          show={show}
          onHide={() => {
            this.hideModal();
          }}
          animation={false}
        >
          <Modal.Header closeButton>
            <Modal.Title>{this.getTitle()}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form onSubmit={(event) => this.addOrUpdate(event)}>
              <Form.Group className="mb-3" key={id}>
                <Form.Label>От:</Form.Label>
                <Form.Control
                  type="number"
                  name="date_min"
                  value={date_min}
                  onChange={this.handleChange}
                />
                <Form.Label>До:</Form.Label>
                <Form.Control
                  type="number"
                  name="date_max"
                  value={date_max}
                  onChange={this.handleChange}
                />
                <Form.Label>Приоритет:</Form.Label>
                <Form.Control
                  type="number"
                  name="priority"
                  value={priority}
                  onChange={this.handleChange}
                />
                <Form.Label>Статус:</Form.Label>
                <Form.Control
                  as="select"
                  onChange={this.handleChange}
                  name="isActive"
                  value={isActive}
                >
                  <option value="true">Актив</option>
                  <option value="false">Пассив</option>
                </Form.Control>
              </Form.Group>
              <Button variant="primary" type="submit" onClick={this.showModal}>
                Сохранить
              </Button>
            </Form>
          </Modal.Body>
        </Modal>
        <section id="tab-item-6">
          {permission && <AddButton onClick={() => this.showModal()} />}
          <table className="table table-hover">
            <thead className="thead-light">
              <tr>
                <th>ID</th>
                <th>От</th>
                <th>До</th>
                <th>Приоритет</th>
                <th>Статус</th>
                <th>Действия</th>
              </tr>
            </thead>
            <tbody>
              {this.state.days.map((day) => (
                <tr key={day.id}>
                  <td>{day.id}</td>
                  <td>{day.date_min}</td>
                  <td>{day.date_max}</td>
                  <td>{day.priority}</td>
                  <td>
                    <p
                      className={
                        day.isActive
                          ? "badge badge-light text-success"
                          : "badge badge-light text-danger"
                      }
                      role="alert"
                    >
                      {day.isActive ? "Актив" : "Пассив"}
                    </p>
                  </td>
                  <td>
                    {permission && <EditButton onClick={() => this.get(day)} />}
                    {permission && (
                      <DeleteButton
                        onClick={(event, id) =>
                          this.showConfirmationModal(event, day.id)
                        }
                      />
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </section>
        <Modal
          show={confirm}
          onHide={() => {
            this.hideModal();
          }}
          animation={false}
        >
          <Modal.Header closeButton>
            <Modal.Title>Удалить</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <h5>Вы уверены, что хотите удалить эту информацию?</h5>
            <button
              className="btn btn-danger m-1"
              onClick={(event) => this.delete(id, event)}
            >
              Удалить
            </button>
            <button
              className="btn btn-light outline-secondary"
              onClick={() => {
                this.hideModal();
              }}
            >
              Назад
            </button>
          </Modal.Body>
        </Modal>
      </>
    );
  }
}

export default DeliveryDay;
